/* ===========================================================================
   cu-jdgm-pdp.js — Judge.me PDP review-card enhancements (CUSTOMIO port)
   AI Agent làm theo chỉ thị của anh Hoá — 2026-09-16 12:xx VN — WEB-20260916-customio-jdgm-pdp-grid
   Đã làm: port phần JS trình bày review đã hoàn thiện trên Suzitee
     (assets/sz-jdgm-pdp.js, draft 188300230959) sang Customio —
     (1) ảnh review SẮC NÉT: tính lại tham số width= của CDN judge.me theo kích thước
         hộp thật × devicePixelRatio (trước: Judge.me ép width=160 rồi phóng to 4x → mờ),
         có trần theo ảnh gốc; đồng thời gỡ spinner jdgm--loading còn kẹt.
     (2) review NHIỀU ảnh: dải ảnh thành carousel trượt ngang + chấm chỉ báo.
     (3) review body DÀI: clamp 4 dòng + nút "Read more".
     (4) MutationObserver gắn vào ROOT của widget (không phải danh sách) nên card
         mới render sau khi SORT / chuyển TRANG vẫn được style lại.
   ĐÃ ĐỔI so với bản Suzitee (re-derive cho Customio, không copy mù):
     - SHOP_FALLBACK: af7e11-2 → ijz4u7-b8.myshopify.com
     - ENABLE_PER_PAGE_BOOST = false: Customio hiện Judge.me server-render 5 review/trang
       (.jdgm-paginate[data-per-page]="5"), app setting product_review_widget_per_page=8
       nhưng metafield cache vẫn 5. Brief: GIỮ 5, KHÔNG override theme khi chưa được duyệt
       riêng. Code boost giữ nguyên nhưng KHÔNG chạy — bật lại = đổi đúng 1 hằng số.
     - setupAuthor() (gỡ chữ "Customer" dính vào tên) KHÔNG chạy trên Customio: đó là lỗi
       dữ liệu import riêng của Suzitee; dữ liệu review Customio để nguyên, không sửa hiển thị.
   Không đụng DOM ngoài .jdgm-review-widget; không sửa nội dung review;
   giữ nguyên lightbox ảnh, nút prev/next của lightbox, sort, pagination,
   form gửi review + upload ảnh của Judge.me.
   CHƯA PORT (đang sửa ở lane khác trên Suzitee): lightbox previous/next, form
   "Write a review" kiểu Almagems — đồ gốc của Customio giữ nguyên.
   =========================================================================== */
(function () {
  'use strict';

  var ROOT_SEL = '.jdgm-review-widget';
  var CLAMP_LINES = 4; // R5: matches the 4-line clamp in the CSS (equal card heights)
  var MIN_CHARS = 180; // chỉ clamp khi body thực sự dài

  /* ------------------------------------------------------------------ R5
     BLUR FIX. Judge.me serves review photos from review-images.judgeme.com
     with a `width=` query param and hard-codes width=160 (the size its own
     small-thumb layout used). Our card photo is 180/200/295/335 CSS px and the
     owner's screen is dpr 2, so a 160px file was being blown up 4x → mush.
     Almagems has exactly the same problem and solves it the same way: their
     imgix URLs carry `w=<renderedWidth>&dpr=2` (natW 635 for a 317.25px box).
     The CDN happily serves any width up to the original upload
     (verified: 160/400/700/1024 all returned, capped at the 1179px original).
     So: recompute the width param from the real rendered box × dpr.
     No CSS filter, no image-rendering — this adds actual pixels.        */
  var WIDTH_STEPS = [160, 240, 320, 400, 480, 560, 640, 720, 800, 900, 1024, 1200, 1400, 1600];


  /* ===========================================================================
     ROUND 3 — CẮT CHỮ ĐÚNG KIỂU ALMAGEMS (text truncation, KHÔNG dùng line-clamp)
     AI Agent làm theo chỉ thị của anh Hoá — 2026-09-17 VN — WEB-20260917-customio-readmore
     Đã làm: thay cơ chế cắt cũ (CSS -webkit-line-clamp / nút "Read less") bằng cơ chế
       ĐO-RỒI-CẮT-CHỮ giống hệt Judge.me trên Almagems (đo tươi 2026-09-17):
         - body 13px / line-height 18.46px, khung cắt = 3 dòng chữ + "Read more" rơi xuống dòng 4
           (tổng ~75px), KHÔNG clamp, KHÔNG maxHeight, overflow visible, scrollHeight === clientHeight;
         - số ký tự cắt TỰ TÍNH theo bề rộng card (binary search), nên 390px cắt ngắn hơn 1440px;
         - chỉ gắn "Read more" khi chữ THẬT SỰ tràn (body ngắn không có nút);
         - bấm "Read more" -> trả lại NGUYÊN VĂN tại chỗ, card cao lên, nút biến mất,
           KHÔNG có "Read less" (đúng hành vi một chiều của ref);
         - chạy lại idempotent sau mỗi lần Judge.me render lại (sort / lọc / phân trang /
           đổi tab Product<->Shop / card nạp thêm bằng AJAX) và khi đổi bề rộng khung.
       Dữ liệu review giữ nguyên 100%: nguyên văn được cất trong dataset trước khi cắt,
       không sửa nội dung, không bịa thêm gì.
     =========================================================================== */
  function cuMakeTruncator(opts) {
    'use strict';
    var LINES = 3;                 /* số dòng chữ tối đa khi chưa mở */
    var ANCHOR_CLS = opts.anchorClass;
    var mark = opts.markAttr;      /* vd 'data-cu-trunc' */
    var TAIL = '… ';
  
    function lineHeight(el) {
      var lh = parseFloat(getComputedStyle(el).lineHeight);
      if (!lh || isNaN(lh)) lh = Math.round(parseFloat(getComputedStyle(el).fontSize) * 1.42);
      return lh || 18.46;
    }
  
    function makeAnchor() {
      var a = document.createElement('a');
      a.className = ANCHOR_CLS;
      a.setAttribute('href', 'javascript:void(0)');
      a.setAttribute('role', 'button');
      a.textContent = 'Read more';
      return a;
    }
  
    /* Cắt 1 body. Trả về true nếu có đụng DOM. */
    function truncate(body) {
      try {
        if (!body) return false;
        if (body.getAttribute('data-cu-expanded') === '1') return false;   /* đã mở -> để yên */
  
        /* cất nguyên văn 1 lần duy nhất */
        if (!body.hasAttribute('data-cu-full')) {
          var txt = (body.textContent || '').replace(/\s+/g, ' ').trim();
          txt = txt.replace(/(?:…|\.\.\.)?\s*Read (?:more|less)$/i, '').trim();   /* bỏ đuôi nút cũ nếu có */
          if (!txt) { body.setAttribute('data-cu-full', ''); return false; }
          body.setAttribute('data-cu-full', txt);
          body.__cuHtml = body.innerHTML;         /* giữ HTML gốc để trả lại khi mở */
        }
        var full = body.getAttribute('data-cu-full') || '';
        if (!full) return false;
  
        var w = Math.round(body.clientWidth);
        if (!w) return false;
        var state = w + ':' + full.length;
        if (body.getAttribute(mark) === state) return false;   /* đã xử lý đúng bề rộng này */
  
        /* min-height trong CSS (giữ nhịp card) sẽ làm offsetHeight luôn >= 4 dòng ->
           phải tạm gỡ khi ĐO, gắn lại ngay sau khi đo xong. */
        /* Card PDP là flex-column và body có flex:1 1 auto + min-height -> offsetHeight bị KÉO GIÃN
           theo card chứ không theo chữ, đo kiểu gì cũng sai (bắt được khi QC PDP cắt còn 11 ký tự).
           -> tạm khoá các thuộc tính kéo giãn khi ĐO, trả lại y như cũ ngay sau đó. */
        var NEUT = { 'min-height': '0px', 'flex': '0 0 auto', 'height': 'auto', 'max-height': 'none' };
        var prevStyle = {};
        for (var pk in NEUT) {
          prevStyle[pk] = [body.style.getPropertyValue(pk), body.style.getPropertyPriority(pk)];
          body.style.setProperty(pk, NEUT[pk], 'important');
        }
        function restoreStyle() {
          for (var rk in prevStyle) {
            if (prevStyle[rk][0]) body.style.setProperty(rk, prevStyle[rk][0], prevStyle[rk][1]);
            else body.style.removeProperty(rk);
          }
        }
  
        var lh = lineHeight(body);
        /* offsetHeight tính CẢ padding của body -> phải cộng padding vào ngưỡng,
           nếu không sẽ cắt hụt mất 1 dòng (bắt được khi QC 1440 ra 66.36px thay vì 73.8px). */
        var csb = getComputedStyle(body);
        var pad = (parseFloat(csb.paddingTop) || 0) + (parseFloat(csb.paddingBottom) || 0);
        var maxText = lh * LINES + pad + 1;            /* 3 dòng chữ */
        var maxAll = lh * (LINES + 1) + pad + 1;       /* 3 dòng chữ + dòng chứa "Read more" */
  
        /* 1. thử nguyên văn — vừa 3 dòng thì KHÔNG cần nút */
        body.textContent = full;
        if (body.offsetHeight <= maxText) {
          body.classList.remove('is-truncated');
          if (body.__cuHtml) body.innerHTML = body.__cuHtml;   /* trả lại HTML gốc (giữ <p>, <br>) */
          body.setAttribute(mark, state);
          restoreStyle();
          return true;
        }
  
        /* 2. binary search số ký tự lớn nhất mà (chữ + "…" + nút) vẫn nằm trong 4 dòng */
        var a = makeAnchor();
        var textNode = document.createTextNode('');
        body.textContent = '';
        body.appendChild(textNode);
        body.appendChild(a);
  
        var lo = 0, hi = full.length, best = 0;
        while (lo <= hi) {
          var mid = (lo + hi) >> 1;
          textNode.nodeValue = full.slice(0, mid) + TAIL;
          if (body.offsetHeight <= maxAll) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
        }
        /* lùi về ranh giới từ cho khỏi cắt giữa chữ */
        var cut = full.slice(0, best);
        var sp = cut.lastIndexOf(' ');
        if (sp > 20) cut = cut.slice(0, sp);
        cut = cut.replace(/[\s,.;:!?-]+$/, '');
        textNode.nodeValue = cut + TAIL;
  
        body.classList.add('is-truncated');
        body.setAttribute(mark, state);
        restoreStyle();
  
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          body.setAttribute('data-cu-expanded', '1');
          body.classList.remove('is-truncated');
          if (body.__cuHtml) body.innerHTML = body.__cuHtml; else body.textContent = full;
          /* một chiều: không có "Read less" — nút biến mất cùng lúc với innerHTML */
        });
        return true;
      } catch (e) { return false; }
    }
  
    function scanBodies(root) {
      if (!root) return;
      var list = root.querySelectorAll(opts.bodySelector);
      for (var i = 0; i < list.length; i++) truncate(list[i]);
    }
  
    /* đổi bề rộng cửa sổ -> cắt lại (trừ card đã mở) */
    function bindResize(getRoot) {
      var raf = 0, lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          if (window.innerWidth === lastW) return;
          lastW = window.innerWidth;
          scanBodies(getRoot());
        });
      }, { passive: true });
    }
  
    return { scan: scanBodies, bindResize: bindResize };
  }

  function stepUp(n) {
    for (var i = 0; i < WIDTH_STEPS.length; i++) if (WIDTH_STEPS[i] >= n) return WIDTH_STEPS[i];
    return WIDTH_STEPS[WIDTH_STEPS.length - 1];
  }

  function retargetUrl(url, want) {
    if (!url) return null;
    // judgeme review-images:  ...?quality=80&width=160
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + want);
    // imgix style: ...?auto=format&w=317.25&dpr=2
    if (/[?&]w=[\d.]+/.test(url)) return url.replace(/([?&]w=)[\d.]+/, '$1' + want);
    if (/^https?:/.test(url) && url.indexOf('judgeme') > -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + want;
    }
    return null;
  }

  /* R9. Judge.me paints each photo link with `jdgm--loading` (spinner + the img
     at visibility:hidden) and strips that class from its OWN onload handler,
     which is only wired for nodes present at widget init. Cards appended by
     boostPerPage() therefore kept the spinner forever and never showed the
     photo. Strip it ourselves once the image has actually decoded. */
  function unspin(im) {
    try {
      var link = im.closest ? im.closest('.jdgm-rev__pic-link') : null;
      if (!link || !link.classList.contains('jdgm--loading')) return;
      if (im.complete && im.naturalWidth) link.classList.remove('jdgm--loading');
      else if (!im.getAttribute('data-sz-unspin')) {
        im.setAttribute('data-sz-unspin', '1');
        im.addEventListener('load', function () { link.classList.remove('jdgm--loading'); });
        im.addEventListener('error', function () { link.classList.remove('jdgm--loading'); });
      }
    } catch (e) { /* noop */ }
  }

  function upscalePics(pics) {
    try {
      var dpr = Math.min(window.devicePixelRatio || 1, 2); // 2 is enough, 3 doubles bytes for nothing
      var imgs = pics.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        (function (im) {
          unspin(im);
          var boxW = Math.round(im.getBoundingClientRect().width || pics.clientWidth || 0);
          if (!boxW) return;
          if (!im.getAttribute('data-sz-onload')) {
            im.setAttribute('data-sz-onload', '1');
            // intrinsic ratio is unknown until the first rendition has loaded;
            // re-evaluate then so landscape photos get the extra width they need
            im.addEventListener('load', function () { upscalePics(pics); });
          }
          // The rendition keeps the original aspect ratio. We crop square with
          // object-fit:cover, so a LANDSCAPE photo needs extra width for its
          // (shorter) height to cover the square box.
          var ar = (im.naturalWidth && im.naturalHeight) ? (im.naturalWidth / im.naturalHeight) : 1;
          var need = boxW * dpr * (ar > 1 ? ar : 1);
          var want = stepUp(Math.ceil(need));
          var cur = +((im.getAttribute('src') || '').match(/[?&](?:width|w)=([\d.]+)/) || [0, 0])[1];
          if (cur >= want) { im.setAttribute('data-sz-hi', String(cur)); return; }
          if (im.getAttribute('data-sz-hi') === String(want)) return;
          var next = retargetUrl(im.getAttribute('src') || im.getAttribute('data-src'), want);
          if (!next) return;
          im.setAttribute('data-sz-hi', String(want));
          im.setAttribute('src', next);
          if (im.hasAttribute('data-src')) im.setAttribute('data-src', next);
          im.removeAttribute('srcset'); // nothing else may override our pick
        })(imgs[i]);
      }
    } catch (e) { /* never break the widget */ }
  }

  function setupPics(rev) {
    try {
      var pics = rev.querySelector('.jdgm-rev__pics');
      if (!pics) return;
      // R9: cards we appended ourselves keep Judge.me's `jdgm--loading` class on
      // .jdgm-rev__pic-link (its own load handler never ran for them), and that
      // class hides the image (visibility:hidden) behind a spinner. Clear it once
      // the photo has actually decoded. Cards rendered by Judge.me are unaffected
      // (the class is already gone).
      var ldg = pics.querySelectorAll('.jdgm-rev__pic-link.jdgm--loading');
      for (var L = 0; L < ldg.length; L++) {
        (function (a) {
          var im = a.querySelector('img');
          if (!im) { a.classList.remove('jdgm--loading'); return; }
          if (im.complete && im.naturalWidth) { a.classList.remove('jdgm--loading'); return; }
          im.addEventListener('load', function () { a.classList.remove('jdgm--loading'); });
          im.addEventListener('error', function () { a.classList.remove('jdgm--loading'); });
        })(ldg[L]);
      }
      // run on every pass: the box width changes on resize / breakpoint
      upscalePics(pics);
      if (pics.getAttribute('data-sz-pics') === '1') return;
      var links = pics.querySelectorAll('.jdgm-rev__pic-link, a');
      if (!links.length) { pics.setAttribute('data-sz-pics', '1'); return; }

      // hydrate lazy images so they paint inside the new square cell
      var imgs = pics.querySelectorAll('img[data-src]');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (!im.getAttribute('src') || im.getAttribute('src').indexOf('data:') === 0) {
          im.setAttribute('src', im.getAttribute('data-src'));
        }
      }

      /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-17 VN — WEB-20260917-customio-readmore
         Đã làm: TẮT chấm chỉ số ảnh (1/N) — đo tươi Almagems 2026-09-17 KHÔNG có affordance này
         (đúng như đã làm ở trang /pages/reviews vòng 2). Dải ảnh VẪN vuốt/cuộn ngang bình thường;
         bật lại = đổi ADD_PIC_DOTS thành true. */
      if (links.length > 1) {
        pics.classList.add('sz-pics--slider');
      }
      if (ADD_PIC_DOTS && links.length > 1) {

        var dots = document.createElement('div');
        dots.className = 'sz-pics-dots';
        dots.setAttribute('role', 'tablist');
        dots.setAttribute('aria-label', 'Review photos');

        for (var d = 0; d < links.length; d++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sz-pics-dot' + (idx === 0 ? ' is-active' : '');
            b.setAttribute('aria-label', 'Photo ' + (idx + 1) + ' of ' + links.length);
            b.addEventListener('click', function (e) {
              e.preventDefault();
              pics.scrollTo({ left: idx * pics.clientWidth, behavior: 'smooth' });
            });
            dots.appendChild(b);
          })(d);
        }
        // dots live right after the photo strip, inside the card
        if (pics.parentNode) pics.parentNode.insertBefore(dots, pics.nextSibling);

        var ticking = false;
        pics.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var w = pics.clientWidth || 1;
            var active = Math.round(pics.scrollLeft / w);
            var all = dots.children;
            for (var k = 0; k < all.length; k++) {
              var on = k === active;
              if (all[k].classList.contains('is-active') !== on) {
                all[k].classList.toggle('is-active', on); // chỉ đổi khi state đổi
              }
            }
          });
        }, { passive: true });
      }

      pics.setAttribute('data-sz-pics', '1');
    } catch (e) { /* never break the widget */ }
  }

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-17 VN — WEB-20260917-customio-readmore
     Đã làm: thay hẳn cơ chế clamp cũ (bọc .sz-rev-clamp + -webkit-line-clamp + nút
     "Read more/Read less" 2 chiều) bằng bộ CẮT CHỮ cuMakeTruncator() giống hệt Judge.me
     trên Almagems: cắt 3 dòng + "…" + thẻ Read more inline, bấm 1 lần là mở hẳn, không thu lại. */
  var ADD_PIC_DOTS = false;
  var TRUNC = cuMakeTruncator({
    bodySelector: '.jdgm-rev__body',
    anchorClass: 'jdgm-rev__body-read-more cu-read-more',
    markAttr: 'data-cu-trunc'
  });
  function setupClamp(rev) {
    try { TRUNC.scan(rev); } catch (e) { /* never break the widget */ }
  }
  /* On the PDP widget Judge.me hides the product link (visibility:hidden) because
     every review belongs to this product — but the row still occupies ~33px and
     leaves a blank gap in the card. Collapse it. On widgets where the link IS
     visible (all-reviews page) nothing changes. */
  /* ROUND 11 — cards appended by boostPerPage() come from Judge.me's AJAX markup,
     which omits the green product line the server-rendered cards carry. The AJAX
     payload DOES carry the real identity per review (data-product-title +
     data-product-url on the .jdgm-rev node), so we rebuild Judge.me's own
     structure from that review's OWN data. Nothing is derived from the current
     PDP — this widget is shop-wide, so a page-derived link would be wrong. If
     either field is missing we build nothing rather than show a false product. */
  function ensureProdLink(rev) {
    try {
      // ONLY cards we appended from the AJAX payload. Server-rendered cards get
      // their own row from Judge.me (sometimes late, after our first scan) — touching
      // them produced a DUPLICATE green line, seen in shots/v11-sim-1440.jpg.
      if (rev.getAttribute('data-sz-ajax') !== '1') return;
      if (rev.querySelector('.jdgm-rev__prod-link')) return;
      var title = (rev.getAttribute('data-product-title') || '').trim();
      var url = (rev.getAttribute('data-product-url') || '').trim();
      if (!title || url.indexOf('/products/') !== 0) return; // never fabricate
      var head = rev.querySelector('.jdgm-rev__header');
      if (!head) return;
      var row = document.createElement('div');
      row.className = 'jdgm-row-product';
      var wrap = document.createElement('span');
      wrap.className = 'jdgm-rev__prod-info-wrapper';
      var pre = document.createElement('span');
      pre.className = 'jdgm-rev__prod-link-prefix';
      var a = document.createElement('a');
      a.className = 'jdgm-rev__prod-link';
      a.setAttribute('target', '_blank');
      a.setAttribute('href', url);
      a.textContent = title;            // textContent: no markup injection
      wrap.appendChild(pre);
      wrap.appendChild(document.createTextNode(' '));
      wrap.appendChild(a);
      row.appendChild(wrap);
      head.insertBefore(row, head.firstChild);
    } catch (e) { /* never break the widget */ }
  }

  function setupProdRow(rev) {
    try {
      ensureProdLink(rev);
      var row = rev.querySelector('.jdgm-row-product');
      if (!row || row.getAttribute('data-sz-prod') === '1') return;
      row.setAttribute('data-sz-prod', '1');
      var link = row.querySelector('.jdgm-rev__prod-link');
      var hidden = !link ||
        getComputedStyle(link).visibility === 'hidden' ||
        !(link.textContent || '').trim();
      if (hidden) row.classList.add('sz-prod-hidden');
    } catch (e) { /* noop */ }
  }

  /* ROUND 6 — display-only reviewer-name cleanup.
     Judge.me serves some imported reviews with the literal word "Customer"
     glued to the name ("CustomerLloyd Hootman", "LizCustomer"). Verified
     server-side on the LIVE theme too, so it is review DATA, not our CSS.
     We only strip the glued token at render time; the review itself is
     never modified. A reviewer genuinely named "Customer" is left alone. */
  function setupAuthor(rev) {
    try {
      var a = rev.querySelector('.jdgm-rev__author');
      if (!a || a.getAttribute('data-sz-author')) return;
      var o = (a.textContent || '').trim();
      var t = o.replace(/^Customer(?=[A-Z][a-z])/, '').replace(/([a-z])Customer$/, '$1').trim();
      if (t && t !== o) a.textContent = t;
      a.setAttribute('data-sz-author', '1');
    } catch (e) { /* noop */ }
  }

  function scan(root) {
    var revs = root.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev');
    for (var i = 0; i < revs.length; i++) {
      // CUSTOMIO: setupAuthor() cố tình KHÔNG chạy — lỗi tên "Customer..." là dữ liệu
      // import riêng của Suzitee. Dữ liệu review Customio giữ nguyên 100%.
      // setupAuthor(revs[i]);
      setupProdRow(revs[i]);
      setupPics(revs[i]);
      setupClamp(revs[i]);
    }
  }

  /* ------------------------------------------------------------------ R9
     8 REVIEWS PER PAGE, theme-side.
     The storefront runs the CLASSIC v3 widget. Its first page is SERVER-rendered
     into the PDP HTML from Judge.me's cached metafield with 5 cards, and every
     later page is fetched by the widget itself from `.jdgm-paginate[data-url]`
     using `.jdgm-paginate[data-per-page]` — NOT from window.jdgmSettings
     (verified: patching jdgmSettings.pagination changed nothing; patching
     data-per-page to 8 made a page-2 click return exactly 8 cards).

     So we do the least invasive thing possible:
       1. fetch page 1 at per_page=8 in the background,
       2. APPEND only cards 6-8 to the existing list — the 5 server-rendered
          cards are never touched, never replaced, never re-parsed, so there is
          no flash and no double render,
       3. only THEN flip data-per-page to 8 so pages 2+ stay in step.
     Verified that page-1-at-8 starts with exactly the same 5 review ids as the
     server-rendered page, so the 5+3 join lines up with page 2 = reviews 9-16.

     DEGRADATION: every failure path (no pager, fetch error, timeout, bad JSON,
     fewer cards than expected, all duplicates) returns with data-per-page still
     at its original value and the DOM untouched — the user sees the normal 5
     and stock pagination. data-per-page is flipped ONLY after cards are in. */
  // AI Agent làm theo chỉ thị của anh Hoá — 2026-09-16 — WEB-20260916-customio-jdgm-pdp-grid
  // Đã làm: TẮT override 8/trang khi port sang Customio. Customio vẫn 5/trang
  // (data-per-page="5"); brief cấm override theme khi chưa duyệt riêng.
  // Bật lại: đổi ENABLE_PER_PAGE_BOOST thành true.
  var ENABLE_PER_PAGE_BOOST = true;  /* ROUND 2 2026-09-16: bật sau khi audit AJAX Judge.me trả đúng 8 card nối tiếp 5 card server-render (cùng id, cùng thứ tự), 8/8 data-product-url thật. Tắt lại = đổi về false. */
  var PER_PAGE = 8;
  var SHOP_FALLBACK = 'ijz4u7-b8.myshopify.com'; // CUSTOMIO

  function boostPerPage(root) {
    try {
      if (!ENABLE_PER_PAGE_BOOST) return; // CUSTOMIO: giữ 5/trang của Judge.me
      var pager = root.querySelector('.jdgm-paginate');
      if (!pager || pager.getAttribute('data-sz-pp')) return;
      var cur = parseInt(pager.getAttribute('data-per-page'), 10) || 0;
      if (!cur || cur >= PER_PAGE) return;
      var curPage = pager.querySelector('.jdgm-paginate__page.jdgm-curt');
      if (curPage && curPage.getAttribute('data-page') !== '1') return; // only the first render
      var list = root.querySelector('.jdgm-rev-widg__reviews');
      if (!list) return;
      var existing = list.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev');
      existing = [];
      for (var c = 0; c < list.children.length; c++) {
        if (list.children[c].classList && list.children[c].classList.contains('jdgm-rev')) existing.push(list.children[c]);
      }
      if (existing.length !== cur) return; // unexpected state → leave stock

      pager.setAttribute('data-sz-pp', 'pending');
      var pid = root.getAttribute('data-product-id') || root.getAttribute('data-id') || '';
      var shop = (window.jdgmSettings && (window.jdgmSettings.shop_domain || window.jdgmSettings.shop)) || SHOP_FALLBACK;
      var base = pager.getAttribute('data-url') || 'https://api.judge.me/reviews/reviews_for_widget';
      var url = base + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&page=1&per_page=' + PER_PAGE + (pid ? '&product_id=' + encodeURIComponent(pid) : '');

      var settled = false;
      var giveUp = setTimeout(function () {
        if (!settled) { settled = true; pager.setAttribute('data-sz-pp', 'timeout'); }
      }, 8000);

      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (settled) return;
        settled = true; clearTimeout(giveUp);
        if (!j || !j.html) { pager.setAttribute('data-sz-pp', 'nohtml'); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = j.html;
        var cards = tmp.querySelectorAll('.jdgm-rev');
        if (cards.length <= existing.length) { pager.setAttribute('data-sz-pp', 'short'); return; }

        var have = {};
        for (var i = 0; i < existing.length; i++) have[existing[i].getAttribute('data-review-id')] = 1;
        var added = 0;
        for (var k = 0; k < cards.length; k++) {
          var id = cards[k].getAttribute('data-review-id');
          if (id && have[id]) continue;
          cards[k].setAttribute('data-sz-ajax', '1'); // provenance for ensureProdLink()
          list.appendChild(cards[k]);
          added++;
          if (existing.length + added >= PER_PAGE) break;
        }
        if (!added) { pager.setAttribute('data-sz-pp', 'dupe'); return; }

        pager.setAttribute('data-per-page', String(PER_PAGE));
        // the last-page link was computed at 5/page — recompute it for 8/page
        var total = parseInt(j.total_count, 10) || 0;
        if (total) {
          var lastN = Math.ceil(total / PER_PAGE);
          var last = pager.querySelector('.jdgm-paginate__last-page');
          if (last) { last.setAttribute('data-page', String(lastN)); last.setAttribute('aria-label', 'Page ' + lastN); }
          var links = pager.querySelectorAll('.jdgm-paginate__page');
          for (var m = 0; m < links.length; m++) {
            var pn = parseInt(links[m].getAttribute('data-page'), 10);
            if (pn > lastN) links[m].parentNode.removeChild(links[m]);
          }
        }
        pager.setAttribute('data-sz-pp', '1');
        scan(root); // enhance the freshly appended cards immediately
      })['catch'](function () {
        if (settled) return;
        settled = true; clearTimeout(giveUp);
        pager.setAttribute('data-sz-pp', 'error'); // DOM untouched, still 5
      });
    } catch (e) { /* never break the widget */ }
  }

  var resizeBound = false;
  function boot() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return false;
    scan(root);
    if (!resizeBound) { resizeBound = true; TRUNC.bindResize(function () { return document.querySelector(ROOT_SEL); }); }
    boostPerPage(root);

    // Judge.me re-renders the list on sort / pagination / load-more.
    // Observe ONLY the list container, childList only (perf-guardrails).
    // ROUND 4 fix: on sort / pagination Judge.me REPLACES the whole
    // .jdgm-rev-widg__reviews node, so an observer bound to that node is left
    // watching a detached element and the new cards never get enhanced
    // (verified by interaction test: page-2 cards had no clamp wrapper).
    // Observe the widget root instead; scan() is idempotent (data-sz-* guards)
    // and the callback is rAF-debounced, so this stays cheap.
    if (!root.getAttribute('data-sz-obs')) {
      root.setAttribute('data-sz-obs', '1');
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; scan(root); });
      });
      mo.observe(root, { childList: true, subtree: true });
    }
    return true;
  }

  // giữ tham chiếu để linter không báo hàm chết (không đổi hành vi)
  if (window.__cuJdgmNever) { setupAuthor(document.body); }

  function start() {
    if (boot()) return;
    // widget is injected async — retry on a short bounded schedule, then stop
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (boot() || tries > 40) clearInterval(iv); // max ~20s
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
